import React from 'react';
import { AlertTriangle, ArrowRight } from 'lucide-react';
import { riskFactors } from '../data/mockData';
import { Button } from './ui/button';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import MobileSlider from './MobileSlider';

const RiskCard = ({ risk, index }) => {
  const card = useScrollAnimation({ threshold: 0.12 });
  return (
    <div ref={card.ref} data-testid={`risk-card-${index}`}
      className={`group bg-white/[0.08] border border-white/[0.12] rounded-2xl p-7 hover:border-[#A78BFA]/40 hover:bg-white/[0.12] transition-all duration-300 h-full scroll-fade-up scroll-delay-${index+1} ${card.isVisible?'scroll-visible':''}`}>
      <div className="flex items-center justify-between mb-4">
        <AlertTriangle className={`w-5 h-5 ${risk.severity==='critical'?'text-red-400':'text-[#A78BFA]'}`} strokeWidth={1.5} />
        <span className={`text-[9px] font-semibold uppercase tracking-wider px-2.5 py-1 rounded-full ${risk.severity==='critical'?'bg-red-500/15 text-red-400':'bg-[#A78BFA]/15 text-[#A78BFA]'}`}>{risk.severity==='critical'?'Critical':'Elevated'}</span>
      </div>
      <h3 className="text-lg font-semibold text-white mb-3 tracking-tight" style={{fontFamily:"'Playfair Display',serif"}}>{risk.title}</h3>
      <p className="text-sm font-normal text-white/70 leading-relaxed">{risk.description}</p>
    </div>
  );
};

const RiskSection = ({ onOpenContactForm }) => {
  const header = useScrollAnimation({ threshold: 0.15 });
  return (
    <section data-testid="risk-section" className="py-16 md:py-32 bg-[#1E1B4B] relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <div ref={header.ref} className={`mb-10 md:mb-16 scroll-fade-up ${header.isVisible?'scroll-visible':''}`}>
          <span className="text-xs tracking-[0.2em] uppercase text-red-400 mb-3 block font-semibold">Risk Assessment</span>
          <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight text-white mb-4" style={{fontFamily:"'Playfair Display',serif"}}>The Cost of Inaction.</h2>
          <p className="text-base font-normal text-white/60 leading-relaxed max-w-lg">These risks affect businesses every day — and the cost of remediation always exceeds prevention.</p>
        </div>
        {/* Desktop grid */}
        <div className="hidden md:grid md:grid-cols-3 gap-5">
          {riskFactors.map((r,i)=><RiskCard key={i} risk={r} index={i} />)}
        </div>
        {/* Mobile slider */}
        <div className="md:hidden">
          <MobileSlider>{riskFactors.map((r,i)=><RiskCard key={i} risk={r} index={i} />)}</MobileSlider>
        </div>
        <div className="mt-10 md:mt-12 text-center">
          <Button data-testid="risk-cta-button" onClick={onOpenContactForm} className="btn-gradient text-white font-semibold px-10 py-5 text-sm rounded-full">Protect Your Brand <ArrowRight className="ml-2 w-4 h-4" /></Button>
        </div>
      </div>
    </section>
  );
};
export default RiskSection;
